module.exports = __webpack_public_path__ + "img/start-mini-3.4c2e8e0c.jpg";